module.exports = __webpack_public_path__ + "static/healthcare-icon-af18577358cdfb31eafc1e74617ab9c9.svg";